import {pushEdapEvent} from '../../utils/edap';

export const ACTION_LOCATION = 'city-descendant-linkpile';

export function pushHandlerClickData(lbsId, position) {
    const fastPathEventData = {
        action_location: ACTION_LOCATION,
        event_lbsuuid: lbsId,
        event_refinements: `locality,position:${position}`,
    };

    return () => {
        pushEdapEvent('content_tile.selected', fastPathEventData);
    };
}

export function pushHandlerNext() {
    pushEdapEvent('ux.cards_visible.adjusted', {
        action_location: ACTION_LOCATION,
        event_action: 'next_arrow_clicked',
    });
}

export function pushHandlerPrev() {
    pushEdapEvent('ux.cards_visible.adjusted', {
        action_location: ACTION_LOCATION,
        event_action: 'previous_arrow_clicked',
    });
}
